import React from 'react'
import Peoples from '../components/Peoples.jsx'

const PeoplesPage = () => {

return(
    <Peoples/>
)
}

export default PeoplesPage